import { render, staticRenderFns } from "./SupplierTemplateEmailList.vue?vue&type=template&id=3b37f83a&"
import script from "./SupplierTemplateEmailList.vue?vue&type=script&lang=js&"
export * from "./SupplierTemplateEmailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports